var path = '/templates/zenclerk_s/layout/layout_main+sidebar-left.html';
var html = "<div class=\"zenclerk-zcs-container with-sidebar-left\"><div class=ui-view-container><div class=ui-view-page-content><zcs-sidebar></zcs-sidebar><zcs-main></zcs-main></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/layout/layout_main+sidebar-left.html
// module id = 1367
// module chunks = 0